import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';


import VodUploadModal from './header/vodUploadModal/VodUploadModal';
import VodStreamModal from './header/vodStreamModal/VodStreamModal';
import { CloudUpload, TvMinimalPlay } from 'lucide-react';
import { VideoFile } from '@mui/icons-material';

// 경로에 맞는 title을 찾는 함수
const findMatchingRoute = (routes: any[], path: string) => {
    for (const routeObj of routes) {
        if (routeObj.route === path) {
            return routeObj;
        }
        if (routeObj.children) {
            const matchingChildRoute = findMatchingRoute(routeObj.children, path);
            if (matchingChildRoute) {
                return matchingChildRoute;
            }
        }
    }
    return null;
};

function ContentHeader() {
    const { t } = useTranslation();
    const location = useLocation();
    const naviData = useSelector((state: any) => state.ui.naviData);

    const [navi, setNavi] = useState<React.ReactNode[]>([]);
    const [naviDesc, setNaviDesc] = useState<string | null>(null);
    const [vodUploadModalOpen, setVodUploadModalOpen] = useState(false);
    const [vodStreamModalOpen, setVodStreamModalOpen] = useState(false);
    const [tempPathParts, setTempPathParts] = useState<string[]>([]);

    const renderBreadcrumbItem = (
        currentPath: string,
        matchingRoute: any,
        isLastItem: boolean,
        hasNextItem: boolean
    ) => (
        <React.Fragment key={currentPath}>
            {isLastItem ? (
                <p className="nav-breadcrumb-text nav-breadcrumb-text--current">
                    {currentPath === '/' ? t('navi_data.dashboard.label') : t(`navi_data.${matchingRoute.route.replace(/\//g, '.').replace(/\./, '')}.label`)}
                </p>
            ) : (
                <>
                    <Link to={currentPath} className="nav-breadcrumb-link">
                        <div>
                            {currentPath === '/' ? t('navi_data.dashboard.label') : t(`navi_data.${matchingRoute.route.replace(/\//g, '.').replace(/\./, '')}.label`)}
                        </div>
                    </Link>
                    {hasNextItem && <div className="nav-breadcrumb-separator">&gt;</div>}
                    
                </>
            )}
           
        </React.Fragment>
        
    );

    useEffect(() => {
        if (!naviData?.length) return;

        const pathParts = location.pathname.split("/");
        const limitedPathParts = pathParts.slice(0, 3);
        const tempPathPartsArray = [...limitedPathParts.slice(1)];
        setTempPathParts(tempPathPartsArray);

        const breadcrumbs: React.ReactNode[] = [];
        console.log('tempPathParts', tempPathPartsArray);

        if (tempPathPartsArray[0] === 'settings') {
            setNaviDesc(t('navi_data.settings.desc'));
            breadcrumbs.push(
                <div key="settings" className="nav-breadcrumb-text nav-breadcrumb-text--current">
                    {t('navi_data.settings.label')}
                </div>
            );
            setNavi(breadcrumbs);
            return;
        }

        // tempPathPartsArray의 복사본을 만들어서 사용
        const workingPathParts = [...tempPathPartsArray];

        while (workingPathParts.length > 0) {
            const currentPath = `/${workingPathParts.join("/")}`;
            const matchingRoute = findMatchingRoute(naviData, currentPath);
            if (matchingRoute) {
                const isLastItem = workingPathParts.length === (limitedPathParts.length - 1);

                if (isLastItem) {
                    /*
                    setNaviDesc(currentPath === '/' ? t('navi_data.dashboard.desc') : t(`navi_data.${matchingRoute.route.replace(/\//g, '.').replace(/\./, '')}.desc`));
                    */    
                }

                breadcrumbs.unshift(renderBreadcrumbItem(
                    currentPath,
                    matchingRoute,
                    isLastItem,
                    breadcrumbs.length > 0
                ));
            }

            workingPathParts.pop();
        }
        setNavi(breadcrumbs);

    }, [naviData, location.pathname]);

    return (
        <>
            <div className='header-container' >
                <div className="header-container-content">
                    <div className="header-container-title">
                        <Typography
                            variant="h5"
                        >
                            {navi}
                             <div className="cr"></div>
                        </Typography>
                    </div>
                    <div className="header-container-description">
                        <Typography
                            variant="body2"
                        >
                            {naviDesc ? naviDesc : ''}
                        </Typography>
                    </div>
                </div>

                {tempPathParts[0] === 'vod' && (
                    <div className="header-container-buttons">
                        <Button className='btn-content-header'  onClick={() => setVodUploadModalOpen(true)}>
                            <CloudUpload className="icon-content-header" size={25} />
                        </Button>
                        {
                            /*
                            <Button className="btn-content-header" onClick={() => setVodStreamModalOpen(true)}>
                                <TvMinimalPlay className="icon-content-header"  size={25} />
                            </Button>
                            */ 
                        }

                    </div>
                )}
            </div>

            <VodUploadModal
                modalOpen={vodUploadModalOpen}
                setModalOpen={setVodUploadModalOpen}
                url=""
                idx={0}
            />

            <VodStreamModal
                modalOpen={vodStreamModalOpen}
                setModalOpen={setVodStreamModalOpen}
                url=""
                idx={0}
            />
        </>
    );
}

export default ContentHeader;
